// extracted by mini-css-extract-plugin
module.exports = {"select":"Select_select__3vk2A","wrapper":"Select_wrapper__1xBkQ","left":"Select_left__2t1r1","top":"Select_top__1FzuC","dark":"Select_dark__3poIT"};